import React, { FC } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useForm } from 'react-hook-form';
import { FormData, IAddUserModalProps } from './types';

export const AddUserModal: FC<IAddUserModalProps> = ({ open, handleClose }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>();

  const onSubmit = handleSubmit(() => {
    handleClose();
  });

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Add User</DialogTitle>
      <DialogContent>
        <form className={'flex'} onSubmit={onSubmit}>
          <TextField
            autoFocus
            margin='dense'
            id='name'
            label='Full Name'
            type='text'
            placeholder='Full Name'
            variant='outlined'
            fullWidth
            {...register('name', { required: true })}
            error={errors.name?.type === 'required'}
            helperText={errors.name?.type === 'required' && 'Name is required'}
          />
          <TextField
            autoFocus
            margin='dense'
            id='email'
            label='Email Address'
            type='email'
            placeholder='Email Address'
            variant='outlined'
            fullWidth
            {...register('email', { required: true })}
            error={errors.email?.type === 'required'}
            helperText={errors.email?.type === 'required' && 'Email is required'}
          />
          <TextField
            autoFocus
            margin='dense'
            id='password'
            label='Password'
            type='password'
            placeholder='Password'
            variant='outlined'
            fullWidth
            {...register('password', { required: true })}
            error={errors.password?.type === 'required'}
            helperText={errors.password?.type === 'required' && 'Password is required'}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type='submit' variant='contained' color='primary' onClick={onSubmit}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};
